// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

type Props = {
  children: Node,
};

export function Select({ children, ...rest }: Props): Node {
  return (
    <Root>
      <Selector {...rest}>
        {children}
      </Selector>

      <ChevronIcon xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.355 0L7 5.344 1.645 0 0 1.644l7 7.002 7-7.002z"
          fill="#738093"
          fillRule="evenodd"
        />
      </ChevronIcon>
    </Root>
  );
}

const Selector = styled.select`
  appearance: none;
  line-height: 48px;
  padding: 0 14px;
  border: 1px solid rgb(203, 203, 203);
  border-radius: 3px;
  outline: 0;
  background: rgb(255,255,255);
  width: 100%;

  &:focus {
    border-color: rgb(35, 151, 212);
  }

  &[readonly] {
    pointer-events: none;
    touch-action: none;
  }
`;

export const Option = styled.option``;

const Root = styled.div`
  position: relative;
`;

const ChevronIcon = styled.svg`
    position: absolute;
    margin-top: -4.5px;
    right: 16px;
    top: 50%;
    height: 9px;
    width: 14px;
    fill: #999;
    pointer-events: none;
`;
